import Icon from '@ant-design/icons'
import images from 'assets/imagesAsset'

const VTPaySvg = () => (
  <img height="24px" width="24px" src={images.viettin} alt="vietin" />
)

const VTPayIcon = (props: any) => <Icon component={VTPaySvg} {...props} />
export default VTPayIcon
